import React from "react";

function ReReSubject(props) {
  const { reRegSubject, selectedSubjects, currentIndex  } = props;
  return (
    <>
      {reRegSubject.map((el, i) => {
        const taken = selectedSubjects?.length > 0 && selectedSubjects.some(
          (s, j) => j !== currentIndex && s.subject == el.intakeID
        );
        if (taken) return null;

        return (
          <option key={i} value={el.intakeID}>
            {`${el.courseName} - (Intake ${el.number}-${el.year})`}
          </option>
        );
      })}
    </>
  );
}

export default ReReSubject;